import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const loginUser = createAsyncThunk(
  "login/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.LOGIN_USER,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const verifyForceOtp = createAsyncThunk(
  "login/verifyForceOtp",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.VERIFY_OTP,
        credentials
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// ------------------ INITIAL STATE ------------------
const initialState = {
  loading: false,
  error: null,
  data: null,
  verify: {
    loading: false,
    error: null,
    data: null,
  },
};

// ------------------ SLICE ------------------
const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // LOGIN USER
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        console.log("action.payload;", action);
      })
      .addCase(verifyForceOtp.pending, (state) => {
        state.verify.loading = true;
        state.verify.error = null;
      })
      .addCase(verifyForceOtp.fulfilled, (state, action) => {
        state.verify.loading = false;
        state.verify.data = action.payload;
      })
      .addCase(verifyForceOtp.rejected, (state, action) => {
        state.verify.loading = false;
        state.verify.error = action.payload;
      });
  },
});

export default loginSlice.reducer;
